import React from "react";

export const muiAbtn = {
  backgroundColor: "#212C62",
  color: "#fff",
  marginLeft: 16,
  borderRadius:"28px",
  padding:"8px 15px"
};
export const muiBbtn = {
  backgroundColor: "#212C62",
  color: "#fff",
  borderRadius:"28px",
  padding:"8px 30px"
};

export const starIcon = {
  color: "#ff8a00",
};


